export var buildEnv = {
  sdkVersion: "3.1.3",
  sdkName: 'df_web_rum_sdk'
};
//# sourceMappingURL=buildEnv.js.map